// Grupo "ATC - Acquisition" (User.cs_groups) + IT y dirección.
// El CRM no lee cs_groups, así que la lista va a mano: si cambia el grupo, hay
// que tocar este fichero.
const authorizedCustomerPlanUsers = [
  // ATC - Acquisition
  'marcela@foodforjoe.es',
  'judith.sanchez@foodforjoe.es',
  'abenchara@foodforjoe.es',
  'ariadna@foodforjoe.es',
  'berengere@foodforjoe.es',
  'tania@foodforjoe.es',
  'carmen.puente@foodforjoe.es',
  'helena.torres@foodforjoe.es',
  'elena@foodforjoe.es',
  // IT y dirección
  'daniel.garrido@foodforjoe.es',
  'paolo.troni@foodforjoe.es',
  'diego@foodforjoe.es',
  'albane@foodforjoe.es',
];

export default authorizedCustomerPlanUsers;
